import React from 'react';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { DBRadioButton } from '_components';
import styles from './Common.module.css';
import { getPanels } from '_helpers';
import {
    PatientCareCenterNoteObjectiveROMPanel,
    PatientCareCenterNoteObjectiveMcKenzie,
    ROMHandTemplate
} from 'PatientCareCenter/Note/Objective/ROM';


class PatientCareCenterNoteObjectiveROM extends React.Component {

    componentDidMount() {
        if (this.props.ROSPINEINPERCENT === undefined || this.props.ROSPINEINPERCENT === null) {
            this.props.updateBitField(this.props.noteId, 'PTOBJECTIVEROM', 'RONO', this.props.rono, 'ROSPINEINPERCENT', false);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.ROSPINEINPERCENT === undefined || this.props.ROSPINEINPERCENT === null) {
            this.props.updateBitField(this.props.noteId, 'PTOBJECTIVEROM', 'RONO', this.props.rono, 'ROSPINEINPERCENT', false);
        }
    }


    handleValueChange() {
        this.props.clearSpineFields(this.props.noteId);
    }


    render() {
        return (
            <span>
                {(this.props.panels.length > 0 || this.props.mckenziePanels.length > 0) &&
                    <PatientCareCenterNoteSection id='obj_rom' name='Range of Motion' level={1}>
                        <div className={styles.row}>
                            <span className={styles.flag} />* indicates with pain
                        </div>

                        {this.props.panelsIncludeSpine && !this.props.isWc && 
                            <div className={styles.row}>
                                <span className={styles.flag} />
                                <label className={styles.label}>Spine measurements in:</label>
                                <DBRadioButton
                                    noteId={this.props.noteId}
                                    entity='PTOBJECTIVEROM'
                                    entityKeyColumn='RONO'
                                    entityKeyValue={this.props.rono}
                                    field='ROSPINEINPERCENT'
                                    label='Degrees'
                                    selectedValue={false}
                                    className={styles.radio_cell}
                                    onClick={() => this.handleValueChange()}
                                />
                                <DBRadioButton
                                    noteId={this.props.noteId}
                                    entity='PTOBJECTIVEROM'
                                    entityKeyColumn='RONO'
                                    entityKeyValue={this.props.rono}
                                    field='ROSPINEINPERCENT'
                                    label='Percent'
                                    selectedValue={true}
                                    className={styles.radio_cell}
                                    onClick={() => this.handleValueChange()}
                                />
                            </div>

                        }
                        {this.props.panels.length > 0 &&
                            <span>
                                <div className={styles.row}>
                                    <div className={styles.flag} />
                                    <div className={styles.label} />
                                    <div className={styles.rom_headers}>AROM</div>
                                    <div className={styles.prom_arom_spacer} />
                                    <div className={styles.rom_headers}>PROM</div>
                                </div>

                                <div className={styles.row}>
                                    <div className={styles.flag} />
                                    <div className={styles.label} />
                                    <div className={styles.arom_r_header}>R</div>
                                    <div className={styles.arom_c_header} />
                                    <div className={styles.arom_l_header}>L</div>
                                    <div className={styles.prom_arom_spacer} />
                                    <div className={styles.prom_r_header}>R</div>
                                    <div className={styles.prom_c_header} />
                                    <div className={styles.prom_l_header}>L</div>
                                </div>
                            </span>
                        }
                        {
                            Object.keys(this.props.panels)
                                .map(key => {
                                    return (<PatientCareCenterNoteObjectiveROMPanel key={this.props.panels[key].MOPNO} panelId={this.props.panels[key].MOPNO} />);
                                })

                        }
                        {this.props.isHandSelected &&
                            <ROMHandTemplate />
                        }
                        <PatientCareCenterNoteObjectiveMcKenzie />

                    </PatientCareCenterNoteSection>
                }
            </span>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        clearSpineFields: bindActionCreators(noteActions.clearSpineFields, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let rono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEROM)
        .find(key => (state.entities.notes.PTOBJECTIVEROM[key].ROEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEROM[key].RONTNO === pk && noteType !== 1)));
    let panels = getPanels(noteId, 'ROM');
    let degreeKeys = state.entities.masterData.PROPS['PTERO_SPINE_DEGREE_PANELS'].PRVALUE.split(',').map(Number);
    let percentKeys = state.entities.masterData.PROPS['PTERO_SPINE_PERCENT_PANELS'].PRVALUE.split(',').map(Number);
    let ROSPINEINPERCENT = state.entities.notes.PTOBJECTIVEROM[rono].ROSPINEINPERCENT;
    var allKeys = degreeKeys.concat(percentKeys);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isWc = state.entities.admissions[epno].isWc;
    let panelsIncludeSpine = Object.keys(panels)
        .filter(key => {
            return allKeys.includes(panels[key].MOPNO)
        }).length > 0 ? true : false;


    if (ROSPINEINPERCENT) {
        // filter out degree panels
        panels = Object.keys(panels)
            .filter(key => {
                return !degreeKeys.includes(panels[key].MOPNO);
            })
            .map(key => panels[key]);
    } else {
        // filter out percent panels
        panels = Object.keys(panels)
            .filter(key => {
                return !percentKeys.includes(panels[key].MOPNO);
            })
            .map(key => panels[key]);
    }

    let isHandSelected = Object.keys(state.entities.notes.PTOBJECTIVETEMPLATESXREF)
        .filter(key => {
            return (noteType === 1 && state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBEVNO === pk && state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBTENO == 16) ||
                (noteType !== 1 && state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBNTNO === pk && state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBTENO == 16)
        }).length > 0 ? true : false;


    return {
        noteId,
        rono,
        panels,
        panelsIncludeSpine,
        mckenziePanels: getPanels(noteId, 'ROMMcKenzie'),
        ROSPINEINPERCENT,
        isHandSelected,
        isWc
    };
}

const connectedPatientCareCenterNoteObjectiveROM = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveROM);
export { connectedPatientCareCenterNoteObjectiveROM as PatientCareCenterNoteObjectiveROM };

